import { render, staticRenderFns } from "./FlightAirlinesForm.vue?vue&type=template&id=4882043f&"
import script from "./FlightAirlinesForm.vue?vue&type=script&lang=js&"
export * from "./FlightAirlinesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports